import { createContext, useContext, useState, useEffect } from 'react'

const ResponsiveContext = createContext(null)

/**
 * ResponsiveProvider - Provides responsive breakpoint information
 * Simple replacement for the deleted widget system's ResponsiveDesign
 */
export const ResponsiveProvider = ({ children }) => {
  const [breakpoints, setBreakpoints] = useState({
    isMobile: false,
    isTablet: false,
    isDesktop: true
  })

  useEffect(() => {
    const updateBreakpoints = () => {
      const width = window.innerWidth
      setBreakpoints({
        isMobile: width < 768,
        isTablet: width >= 768 && width < 1024,
        isDesktop: width >= 1024
      })
    }

    updateBreakpoints()
    window.addEventListener('resize', updateBreakpoints)
    return () => window.removeEventListener('resize', updateBreakpoints)
  }, [])

  return (
    <ResponsiveContext.Provider value={breakpoints}>
      {children}
    </ResponsiveContext.Provider>
  )
}

/**
 * useResponsive - Hook to access responsive breakpoint information
 */
export const useResponsive = () => {
  const context = useContext(ResponsiveContext)
  if (!context) {
    // Fallback if used outside provider
    const width = typeof window !== 'undefined' ? window.innerWidth : 1024
    return {
      isMobile: width < 768,
      isTablet: width >= 768 && width < 1024,
      isDesktop: width >= 1024
    }
  }
  return context
}

